var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"retailer_az"},[_c('div',{staticClass:"loading_wrap"},[_c('a-spin',{attrs:{"spinning":_vm.loading}}),_c('RetailersAZ')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }